import { render, staticRenderFns } from "./Benefits3.vue?vue&type=template&id=1cfc3c7c&scoped=true"
import script from "./Benefits3.vue?vue&type=script&lang=js"
export * from "./Benefits3.vue?vue&type=script&lang=js"
import style0 from "./Benefits3.vue?vue&type=style&index=0&id=1cfc3c7c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfc3c7c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VChip,VCol,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/Users/afonsomonteiro/onboarding/onboarding/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cfc3c7c')) {
      api.createRecord('1cfc3c7c', component.options)
    } else {
      api.reload('1cfc3c7c', component.options)
    }
    module.hot.accept("./Benefits3.vue?vue&type=template&id=1cfc3c7c&scoped=true", function () {
      api.rerender('1cfc3c7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Simulador/Benefits3.vue"
export default component.exports